export enum RiskMatrixLevel {
  low,
  warning,
  danger,
}
export enum DegreeOfSupervisionString {
  'Low',
  'Medium',
  'High'
}
export enum RiskMatrixLevelString {
  '1 - Low',
  '2 - Warning',
  '3 - Danger',
  '4 - Low',
  '5 - Warning',
  '6 - Danger'
}
// export enum RiskMatrixLevel {
//   nonElectrical,
//   low,
//   warning,
//   danger,
//
//
// }
// export enum DegreeOfSupervisionString {
//   'Non Electrical',
//   'Low',
//   'Medium',
//   'High',
//
// }
// export enum RiskMatrixLevelString {
//   '0 - Non Electrical',
//   '1 - Low',
//   '2 - Warning',
//   '3 - Danger',
//
// }
